/**
 * Store admin home (Commerce, V1.0.1) — the module's landing route.
 *
 * Reached from the launch-page "Store" tile; the surrounding "Store" nav group
 * is gated by the `commerce.admin` entitlement (`nav-config.ts`), so this route
 * is only linked for workspaces with the Commerce Store add-on enabled.
 * @see docs/ecom/v1.0.1-plan.md
 */
import { createFileRoute } from "@tanstack/react-router";
import { StoreAdminHome } from "../../../../features/store/index.ts";

export const Route = createFileRoute("/(workspace)/store/admin/")({
  component: StoreAdminHome,
});
